import axios from 'axios'
export default {
  namespaced: true,
  state: {
    notificationUserGrid: [],
    pageData: null,
  },
  mutations: {
    setNotificationUserGrid(state, payload) {
      state.notificationUserGrid = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    notificationUserGrid: (state) => state.notificationUserGrid,
    pageData: (state) => state.pageData,
  },
  actions: {
    onNotificationUserGrid({ commit, rootState }, { limit, page, sort, search }) {
      let url = rootState.apiDomain + '/api/online/notification'
      // +'?limit=' + limit + '&page=' + page
      // if (sort) {
      //     url = url + '&order[]=' + sort.param + ':' + sort.value
      // } else {
      //     url = url + '&order[]=sent_at:desc'
      // }
      // if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationUserGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationMakeSeen({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/notification/make-seen',
          data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
